
/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { MatDialog } from "@angular/material/dialog";
import { MyInjector } from "@src/app/app.module";
import { Txn } from "@src/app/model/txn";
import { ActionColor, IFormAction } from "@src/app/shared/form/form.component";
import { of } from "rxjs";
import { ShowJSONComponent } from "@src/app/shared/dialogs/show-json/show-json.component";
import { BankReconiliationService } from "@src/app/modules/txn/bank-reconciliation/bank-reconciliation.service";
import { CDSData, ConfirmDialogService } from "@src/app/shared/dialogs/confirmDialog";
import { concatMap, map } from "rxjs/operators";

export class ReconciliationDetailAction implements IFormAction {
    name = $localize`Reconciliation Details`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'receipt';
    approvalNeeded = false;
    disabled = false;
    approvalText: string;
    tipText = $localize `View matching reconciliation items`;
    dialog = MyInjector.instance.get(MatDialog);
    cds = MyInjector.instance.get(ConfirmDialogService);

    txn: Txn;

    action() {
        //return this.dialog.open(BankInEditComponent, { data: this.bankIn }).afterClosed();
        const recSvc = MyInjector.instance.get(BankReconiliationService);
        return recSvc.getItem(this.txn.bankItemId).pipe( concatMap( bankItem => {
            if (!bankItem) return of(this.txn);
            const txnName = `${this.txn.type.name} ${this.txn.refNr}`
            const statementItem = (bankItem.transactionId as string).startsWith('__statement');
            return this.dialog.open(ShowJSONComponent,
                {data: {
                    title: $localize `Reconciliation Detail ${txnName} ${ statementItem ? ' not received from bank, marked manually reconciled' : ''}`, 
                    content: bankItem.data,
                    actionName: statementItem ? null : "Unreconcile",
                    actionReturns: statementItem ? null : 'Unreconcile',
                }
            }).afterClosed().pipe( concatMap( response => {
                if (response === 'Unreconcile') {
                    const cdsData = {
                        title: $localize `Unreconcile ${txnName}`,
                        msg: $localize `
                            Do you want to mark ${txnName}, and any related transactions, as unreconciled, and put it and the matching bank item back into the reconciliation process.
                        `,
                        options: [
                            {name: 'Unreconcile', returns: true},
                            {name: 'Cancel', returns: false} 
                        ]
                    } as CDSData;
                    return this.cds.openChoice(cdsData, false).pipe( concatMap((result) => {
                        if (result) {
                            return recSvc.markUnMatched(this.txn, bankItem).pipe( map(txn => {
                                console.log('All Done');
                                return txn;
                            }));
                        } else {
                            return of(this.txn);
                        }
                        
                    }));
                }
                return of(this.txn);
            }));

        }))
    }

    setup(bi: Txn) {
        this.txn = bi;
        this.disabled = true;
        if (bi.bankItemId) {
            this.disabled = false;
        } else {
            this.disabled = true;
        }
        this.show = true;
    }
}
